import { render, staticRenderFns } from "./QuotationButtons.vue?vue&type=template&id=fc820116&scoped=true&lang=html"
import script from "./QuotationButtons.vue?vue&type=script&lang=js"
export * from "./QuotationButtons.vue?vue&type=script&lang=js"
import style0 from "./QuotationButtons.vue?vue&type=style&index=0&id=fc820116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc820116",
  null
  
)

export default component.exports